import { BaseRouteService } from 'core/services';

class PackingSlipRouteService extends BaseRouteService {
	constructor() {
		super();
		this.base = 'packing-slip/';
	}

	generatePdf(id, isManual) {
		return super.get(this.base + 'generate/{id}/?isManual={isManual}', id, { isManual });
	}
}

export default PackingSlipRouteService;
